'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './mail-list.routes';

export class MailListComponent {

  constructor(Auth, dialogs, $uibModal, MailsService, $stateParams, $location, Upload) {
    'ngInject';
    this.dialogs = dialogs;
    this.$uibModal = $uibModal;
    this.MailsService = MailsService;
    this.Upload = Upload;
    this.$stateParams = $stateParams;
    this.Auth = Auth;
    this.$location = $location;

    this.type = $stateParams.type;

    this.noData = false;
    this.count = {};

    this.MailsService.getByType({type: this.type}, (data) => {
      this.mailLists = data;

      if (this.mailLists.length == 0) {
        this.noData = true;
      }
    }, err => {
      console.log("Could not retrieve mail lists from server.")
    });

    this.MailsService.query(data => {
      data.forEach(mail => {
        if (mail.type) {
          if (!this.count[mail.type]) {
            this.count[mail.type] = 0;
          }
          this.count[mail.type]++;
        }
      })
    });

  }

  openRecipientsModal(mail) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'datatableViewer',
      resolve: {
        config: function () {
          return {
            data: mail.recipients.map(mail => [mail]) || [],
            settings: {
              "columns": [
                "Email"
              ]
            },
            name: mail.subject + " Recipient List"
          }
        }
      },
      size: 'lg'
    });
  }

  send(mail) {

    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'mailComposerFilterSendComponent',
      resolve: {
        config: function() {
          return {
            mail: mail
          }
        }
      },
      size: 'lg',
      windowClass: 'xl-modal'
    });

    modalInstance.result.then(
      function (result) {

        let id = result.mailId;

        that.mailLists = that.mailLists.filter(function( obj ) {
          return obj._id !== id;
        });

        if (that.mailLists.length == 0) {
          that.noData = true;
        }

        that.count["draft"]--;
        that.count["sent"]++;

        that.dialogs.notify("Mail has been sent", "The mail has been sent successfully");

      },
      function () { /* cancel */ }
    );

  }

  delete(mail) {
    var that = this;

    var listText = "<br/><br/><b>" + mail.subject + "</b>";

    var dlg = this.dialogs.confirm("Delete Mail?", "Do you really want to delete this mail?" + listText);
    dlg.result.then(() => {
      // OK delete it
      that.MailsService.delete({id: mail._id},
        () => {
          that.mailLists = that.mailLists.filter(function( obj ) {
            return obj._id !== mail._id;
          });

          that.count[that.type]--;
        },
        err => {
          alert("Could not delete mail");
        });
    }, () => {
      // Cancel
    });
  }

  clone(mail) {
    var that = this;

    var listText = "<br/><br/><b>" + mail.subject + "</b>";

    var dlg = this.dialogs.confirm("Clone Mail?", "Do you want to clone this mail?" + listText + "<br/><br/>The mail will be opened in the mail composer after it has been cloned");
    dlg.result.then(() => {

      let clonedMail = angular.copy(mail);

      delete clonedMail._id;
      delete clonedMail.sentDate;
      delete clonedMail.recipients;
      delete clonedMail.meta.creationDate;

      clonedMail.type = 'draft';
      clonedMail.subject += " (Cloned " + new Date().toLocaleString() + ")";

      clonedMail.meta.creationUser = that.Auth.getCurrentUserSync()._id;
      clonedMail.meta.active = true;

      that.MailsService.save(clonedMail,
        (newMail) => {
          that.$location.path("/mail/composer/" + newMail._id);
        },
        err => {
          alert("Could create mail");
        });
    }, () => {
      // Cancel
    });
  }

  openPreviewModal(mail) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'mailComposerPreviewComponent',
      resolve: {
        config: function() {
          return {
            url: '/api/mails/html/'+mail._id,
            title: mail.subject
          }
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function () { /* ok */ },
      function () { /* cancel */ }
    );

  }
}

export default angular.module('conduu.mailList', [uiRouter])
  .config(routes)
  .component('mailList', {
    template: require('./mail-list.html'),
    controller: MailListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/messaging/mail/list/mail-list.component.js